import React from "react";
import { RadioGroup } from "@headlessui/react";
import { Controller } from "react-hook-form";
import classNames from "lib/classNames";
import useField from "lib/useField";

export default function Radios({ control, errors, field }) {
  const { name, disabled, required, requiredMessage, options } =
    useField(field);
  const hasError = errors[name] || false;

  if (options === null) {
    return null;
  }

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: required && requiredMessage,
        disabled,
      }}
      render={({ field: { value, onChange } }) => (
        <RadioGroup value={value} onChange={onChange}>
          <RadioGroup.Label
            className={classNames(
              hasError && "text-red-500",
              "inline-block mb-1 font-important font-medium uppercase text-sm"
            )}
          >
            {field["#title"]}
            {required && <span className="text-primary"> *</span>}
          </RadioGroup.Label>

          {hasError && (
            <p className="text-sm text-red-500 mb-2 font-semibold">
              {errors[name].message}
            </p>
          )}

          <div className="flex flex-col gap-2">
            {options.map((option) => (
              <RadioGroup.Option
                key={option.value}
                value={option.value}
                className="mt-1 cursor-pointer"
              >
                {({ checked }) => (
                  <div className={classNames("flex items-center gap-4")}>
                    <span className="flex items-center justify-center p-2  border border-primary bg-gray-100 rounded-full transition-colors">
                      <span
                        className={classNames(
                          "h-2 w-2 rounded-full transition-colors",
                          checked && "bg-primary"
                        )}
                      />
                      <span className="sr-only">
                        {checked ? "Coché" : "Non Coché"}
                      </span>
                    </span>
                    <span>{option.key}</span>
                  </div>
                )}
              </RadioGroup.Option>
            ))}
          </div>
        </RadioGroup>
      )}
    />
  );
}
